export default class Thick {
  public constructor(
    public readonly top: number,
    public readonly side: number,
    public readonly bottom: number
  ) {}
}


// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Thick.ts